import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnMount: false,
      retry: false,
      refetchOnWindowFocus: false,
      gcTime: 20000,
    },
  },
});
